// @flow

import React from 'react';
import bemify from 'bemify-js';
import { pure } from 'recompose';

import AbbreviatedNumber from 'app/common/components/AbbreviatedNumber';
import Hoverable from 'app/common/components/Hoverable';
import Icon from 'app/common/components/Icon';
import Popover from 'app/common/components/Popover';
import PopoverMessage from 'app/common/components/PopoverMessage';
import ProgressBar from 'app/common/components/ProgressBar';
import TruncatedText from 'app/common/components/TruncatedText';
import { uninfinitize } from 'app/common/CommonUtils';
import 'app/common/components/UsageDetailsBar.scss';

import type { HOC } from 'recompose';

type UsageDetailsBarProps = {
  label: string,
  max: number,
  value: number,
  className?: string,
  tooltipContent: string,
};

const UsageDetailsBar = props => {
  const bem = bemify('usage-details');
  const tooltip = !!props.tooltipContent && (
    <Hoverable tag="span">
      {({ isHovered }) => (
        <Popover kind="simple dark compact">
          <Icon className={bem('__tooltip-icon')} size={13} type="info" />
          {isHovered && <PopoverMessage>{props.tooltipContent}</PopoverMessage>}
        </Popover>
      )}
    </Hoverable>
  );
  return (
    <div className={bem(props.className)}>
      <div className={bem('__text')}>
        <TruncatedText className={bem('__label')}>{props.label}</TruncatedText>
        {tooltip}
        <TruncatedText className={bem('__label')}>
          <AbbreviatedNumber number={props.value} /> /{' '}
          {props.max === Infinity ? (
            uninfinitize(props.max)
          ) : (
            <AbbreviatedNumber number={props.max} />
          )}
        </TruncatedText>
      </div>
      <ProgressBar
        className={bem('__progress-bar')}
        max={props.max}
        value={props.value}
      />
    </div>
  );
};

const enhanceUsageDetailsBar: HOC<*, UsageDetailsBarProps> = pure;

export default enhanceUsageDetailsBar(UsageDetailsBar);
